import { cn } from "@/lib/utils";
import Image from "next/image";
import { ArrowRightSVG } from "../../assets/favicons";

interface LoadMoreProps {
  className?: string;
  onClick?: () => void;
  text?: string;
  textColor?: string;
  backgroundColor?: string;
  icon?: string;
  iconAlt?: string;
}

function LoadMore({
  className,
  onClick,
  text = "Load More",
  textColor = "#F74958",
  backgroundColor,
  icon,
  iconAlt,
}: LoadMoreProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "text-heading-8-semibold flex gap-spacing-4 cursor-pointer items-center",
        backgroundColor ? "px-4 py-2 rounded" : "",
        className
      )}
      style={{
        color: textColor,
        backgroundColor: backgroundColor || "transparent",
      }}
    >
      {text}
      {icon ? (
        <Image src={icon} alt={iconAlt || "Load more"} width={20} height={20} />
      ) : (
        <ArrowRightSVG color={textColor} />
      )}
    </button>
  );
}

export default LoadMore;
